/**
 * Calculate total annual savings from recommendations
 */
export const calculateTotalSavings = (recommendations) => {
  if (!recommendations || !Array.isArray(recommendations)) {
    return 0;
  }
  return recommendations.reduce((sum, rec) => sum + (rec.annual_savings || 0), 0);
};

/**
 * Calculate average payback period from recommendations
 */
export const calculateAveragePayback = (recommendations) => {
  if (!recommendations || !Array.isArray(recommendations) || recommendations.length === 0) {
    return 0;
  }
  const totalPayback = recommendations.reduce((sum, rec) => sum + (rec.payback_years || 0), 0);
  return totalPayback / recommendations.length;
};

/**
 * Get recommendations filtered by cost category
 */
export const getRecommendationsByCategory = (recommendations, category) => {
  if (!recommendations || !Array.isArray(recommendations)) {
    return [];
  }
  return recommendations.filter(r => r.cost_category === category);
};

/**
 * Calculate savings percentage based on annual energy spend
 */
export const calculateSavingsPercentage = (totalSavings, annualEnergySpend) => {
  if (!annualEnergySpend || annualEnergySpend === 0) {
    return 0;
  }
  return (totalSavings / annualEnergySpend) * 100;
};

/**
 * Get top recommendations sorted by annual savings
 */
export const getTopRecommendations = (recommendations, limit = 6) => {
  if (!recommendations || !Array.isArray(recommendations)) {
    return [];
  }
  return recommendations
    .sort((a, b) => (b.annual_savings || 0) - (a.annual_savings || 0))
    .slice(0, limit);
};

